import { useChartTheme } from '@revelio/replots';

const PLAYER_COLOR_TOKENS = {
  light: '--ui-text-normal',
  dark: '--ui-surface-floating',
} as const;

export const useThemedWistiaPlayerColor = (): string | undefined => {
  const { theme } = useChartTheme();

  if (typeof document === 'undefined') return undefined;

  const value = getComputedStyle(document.body)
    .getPropertyValue(PLAYER_COLOR_TOKENS[theme])
    .trim();
  if (!value) return undefined;

  return value.startsWith('#') ? value.slice(1) : value;
};
